<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item
                label="设备ID,关联{zb_equipment.id}"
                prop="equipmentId"
              >
                <a-input
                  v-model:value="queryParam.equipmentId"
                  placeholder="请输入设备ID,关联{zb_equipment.id}"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="耗材名称" prop="name">
                <a-input
                  v-model:value="queryParam.name"
                  placeholder="请输入耗材名称"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="耗材更换使用量" prop="consumablesUsage">
                  <a-input
                    v-model:value="queryParam.consumablesUsage"
                    placeholder="请输入耗材更换使用量"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="耗材型号" prop="consumablesModel">
                  <a-input
                    v-model:value="queryParam.consumablesModel"
                    placeholder="请输入耗材型号"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="耗材更换时间" prop="consumablesChange">
                  <a-date-picker
                    style="width: 100%"
                    v-model:value="queryParam.consumablesChange"
                    format="YYYY-MM-DD HH:mm:ss"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="下次更换时间" prop="nextChange">
                  <a-date-picker
                    style="width: 100%"
                    v-model:value="queryParam.nextChange"
                    format="YYYY-MM-DD HH:mm:ss"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="更换预警次数" prop="changeTimes">
                  <a-input
                    v-model:value="queryParam.changeTimes"
                    placeholder="请输入更换预警次数"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="最新耗材预警时间" prop="warningDate">
                  <a-date-picker
                    style="width: 100%"
                    v-model:value="queryParam.warningDate"
                    format="YYYY-MM-DD HH:mm:ss"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="排序" prop="sort">
                  <a-input
                    v-model:value="queryParam.sort"
                    placeholder="请输入排序"
                    allow-clear
                  />
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="handleQuery"
                  ><a-icon type="search" />查询</a-button
                >
                <a-button style="margin-left: 8px" @click="resetQuery"
                  >重置</a-button
                >
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button
          type="primary"
          @click="$refs.createForm.handleAdd()"
          v-hasPermi="['system:equipmentConsumables:add']"
        >
          <a-icon type="plus" />新增
        </a-button>
        <a-button
          type="primary"
          :disabled="single"
          @click="$refs.createForm.handleUpdate(undefined, ids)"
          v-hasPermi="['system:equipmentConsumables:edit']"
        >
          <a-icon type="edit" />修改
        </a-button>
        <a-button
          type="danger"
          :disabled="multiple"
          @click="handleDelete"
          v-hasPermi="['system:equipmentConsumables:remove']"
        >
          <a-icon type="delete" />删除
        </a-button>
        <a-button
          type="primary"
          @click="handleExport"
          v-hasPermi="['system:equipmentConsumables:export']"
        >
          <a-icon type="download" />导出
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          v-model:table-size="tableSize"
          v-model:value="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <create-form ref="createForm" @ok="getList" @close="getList" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <template v-slot:consumablesChange="text, record">
          <span>
            {{ parseTime(record.consumablesChange) }}
          </span>
        </template>
        <template v-slot:nextChange="text, record">
          <span>
            {{ parseTime(record.nextChange) }}
          </span>
        </template>
        <template v-slot:warningDate="text, record">
          <span>
            {{ parseTime(record.warningDate) }}
          </span>
        </template>
        <template v-slot:createTime="text, record">
          <span>
            {{ parseTime(record.createTime) }}
          </span>
        </template>
        <template v-slot:operation="text, record">
          <span>
            <a-divider
              type="vertical"
              v-hasPermi="['system:equipmentConsumables:edit']"
            />
            <a
              @click="$refs.createForm.handleUpdate(record, undefined)"
              v-hasPermi="['system:equipmentConsumables:edit']"
            >
              <a-icon type="edit" />修改
            </a>
            <a-divider
              type="vertical"
              v-hasPermi="['system:equipmentConsumables:remove']"
            />
            <a
              @click="handleDelete(record)"
              v-hasPermi="['system:equipmentConsumables:remove']"
            >
              <a-icon type="delete" />删除
            </a>
          </span>
        </template>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {
  pageEquipmentConsumables,
  listEquipmentConsumables,
  delEquipmentConsumables,
} from '@/api/system/equipmentConsumables'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'EquipmentConsumables',
  components: {
    CreateForm,
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        equipmentId: null,
        name: null,
        consumablesUsage: null,
        consumablesModel: null,
        consumablesChange: null,
        nextChange: null,
        changeTimes: null,
        warningDate: null,
        status: null,
        sort: null,
        pageNum: 1,
        pageSize: 10,
      },
      columns: [
        {
          title: 'id',
          dataIndex: 'id',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '设备ID,关联{zb_equipment.id}',
          dataIndex: 'equipmentId',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '耗材名称',
          dataIndex: 'name',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '耗材更换使用量',
          dataIndex: 'consumablesUsage',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '耗材型号',
          dataIndex: 'consumablesModel',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '耗材更换时间',
          dataIndex: 'consumablesChange',
          scopedSlots: { customRender: 'consumablesChange' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: '下次更换时间',
          dataIndex: 'nextChange',
          scopedSlots: { customRender: 'nextChange' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: '更换预警次数',
          dataIndex: 'changeTimes',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '最新耗材预警时间',
          dataIndex: 'warningDate',
          scopedSlots: { customRender: 'warningDate' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: '是否显示 1显示 0-不显示',
          dataIndex: 'status',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '排序',
          dataIndex: 'sort',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '插入时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center',
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
    }
  },
  created() {
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    /** 查询设备耗材列表 */
    getList() {
      this.loading = true
      pageEquipmentConsumables(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        equipmentId: undefined,
        name: undefined,
        consumablesUsage: undefined,
        consumablesModel: undefined,
        consumablesChange: undefined,
        nextChange: undefined,
        changeTimes: undefined,
        warningDate: undefined,
        status: undefined,
        sort: undefined,
        pageNum: 1,
        pageSize: 10,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk() {
          let data = []
          that.ids.map((id) => data.push({ id: id }))
          return delEquipmentConsumables(data).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        },
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'system/equipment-consumables/export',
            {
              ...that.queryParam,
            },
            `设备耗材_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
